import Vue from "vue";
import purchaseAccessService from "../../services/purchaseAccessService";

const state = {
    list_access: [],
}

const getters = {
    access(state, _, rootState) {
        return state.list_access.find(obj => obj.purchaser === rootState.clients.current_client.id) || {'type': 'A', 'places': [], 'purchaser': rootState.clients.current_client.id}
    }
}

const actions = {
    addPurchaseAccess(store, purchase_access) {
        return new Promise((resolve, reject) => {
            purchaseAccessService.postPurchaseAccess(purchase_access)
                .then(purchase_access => {
                    resolve(purchase_access);
                })
                .catch((error) => {
                    reject();
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось сохранить настройки доступа закупщика.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                });
        });
    },
    editPurchaseAccess(store, purchase_access) {
        return new Promise((resolve, reject) => {
            purchaseAccessService.editPurchaseAccess(purchase_access)
                .then(purchase_access => {
                    resolve(purchase_access);
                })
                .catch((error) => {
                    reject();
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось сохранить настройки доступа закупщика.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                });
        });
    },
    getPurchaseAccess({commit}, params) {
        return new Promise((resolve, reject) => {
            purchaseAccessService.getPurchaseAccess(params)
                .then(purchase_access => {
                    commit('setAccess', purchase_access)
                    resolve(purchase_access);
                })
                .catch((error) => {
                    reject();
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информацию о доступе к закупке.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                });
        });
    },
    reservationAccess(store, data) {
        return new Promise((resolve, reject) => {
            purchaseAccessService.postReservationAccess(data)
                .then(() => {
                    resolve();
                })
                .catch((error) => {
                    reject();
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось забронировать место закупки.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                });
        });
    },
}

const mutations = {
    setAccess(state, data) {
        data.forEach(access => {
            access.places = access.places.filter(place => place !== null);
        })
        state.list_access = data;
    },
    updateAccess(state, data) {
        data.places = data.places.filter(place => place !== null);
        const index = state.list_access.findIndex(obj => obj.purchaser === data.purchaser)
        if (index !== -1) {
            state.list_access.splice(index, 1, data)
        } else {
            state.list_access.push(data)
        }
    }
}

export default {
    namespaced: true,
    mutations,
    getters,
    actions,
    state,
}